'use client';

import Image from 'next/image';
import Box from '@mui/material/Box';

/* The film's closing frame, rebuilt as the page hero so the two read as one
   continuous shot. Values are lifted from the ComingSoon scene in
   components/film/scenes.jsx and scaled from its 1920px stage to the page. */

export default function ComingSoonHero() {
  return (
    <Box
      sx={{
        position: 'relative',
        px: 3,
        py: { xs: 6, md: 9 },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
      }}
    >
      {/* the scene's purple bloom, anchored above the wordmark */}
      <Box
        aria-hidden
        sx={{
          position: 'absolute',
          left: '50%',
          top: '-42%',
          width: '112%',
          aspectRatio: '1 / 1',
          transform: 'translateX(-50%)',
          background:
            'radial-gradient(circle, rgba(91,55,238,.20), rgba(91,55,238,0) 62%)',
          pointerEvents: 'none',
        }}
      />

      <Box sx={{ position: 'relative', width: 'clamp(190px, 23vw, 330px)' }}>
        <Image
          src="/adzilio-lockup-white.png"
          alt="Adzilio"
          width={856}
          height={314}
          priority
          sizes="(max-width: 600px) 190px, 330px"
          style={{ width: '100%', height: 'auto' }}
        />
      </Box>

      <Box
        component="h1"
        sx={{
          m: 0,
          mt: { xs: 3.5, md: 4.5 },
          fontWeight: 800,
          fontSize: 'clamp(2.5rem, 6.6vw, 5.9rem)',
          lineHeight: 1.18,
          letterSpacing: '-0.045em',
          whiteSpace: 'nowrap',
          color: 'transparent',
          background: 'linear-gradient(100deg, #FFFFFF 20%, #C4A4FF 55%, #6EA8FF 90%)',
          WebkitBackgroundClip: 'text',
          backgroundClip: 'text',
        }}
      >
        Coming soon
      </Box>

      <Box
        aria-hidden
        sx={{
          position: 'relative',
          overflow: 'hidden',
          mt: { xs: 3, md: 3.75 },
          width: 'clamp(220px, 27vw, 386px)',
          height: '2px',
          background: 'rgba(168,120,255,.18)',
          /* Runs regardless of prefers-reduced-motion, deliberately. The film
             sweeps this line in its own closing frame and the page is echoing
             that shot; suppressing a 2px highlight while playing a 75s film
             would be inconsistent. */
          '&::after': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            width: '42%',
            height: '2px',
            background:
              'linear-gradient(90deg, rgba(168,120,255,0), #C4A4FF, rgba(110,168,255,0))',
            animation: 'csSweep 3.4s ease-in-out infinite',
          },
          '@keyframes csSweep': {
            '0%': { transform: 'translateX(-100%)' },
            '100%': { transform: 'translateX(238%)' },
          },
        }}
      />

      <Box
        sx={{
          mt: { xs: 3, md: 3.75 },
          fontWeight: 600,
          fontSize: 'clamp(.95rem, 1.75vw, 1.55rem)',
          lineHeight: 1.3,
          color: 'rgba(226,225,255,.8)',
        }}
      >
        AI campaigns, human control, qualified pipeline.
      </Box>
    </Box>
  );
}
